import React, { ReactElement, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '@/contexts/UserContext';
import { PROJECTS_URL } from '@/routePaths';

interface Props {
  children: ReactElement;
}

/**
 * Defensive guard for editor-only routes (brand kit, stream keys, runsheets,
 * integrations, etc.). The sidebar already hides these from speakers, but a
 * speaker who pastes a deep-link URL would otherwise land on the editor
 * page. Redirect them to the projects library instead.
 */
const EditorOnlyRoute = ({ children }: Props): ReactElement => {
  const { userState, isLoadingOrgContext } = useContext(UserContext);

  if (isLoadingOrgContext && !userState?.role) {
    return <></>;
  }

  if (userState?.role === 'user') {
    return <Navigate to={PROJECTS_URL} replace />;
  }

  return children;
};

export default EditorOnlyRoute;
